import MaintenanceWorkflowForwardingCanceled from "../components/tabs/ForwardingsTab/states/Canceled";
import MaintenanceWorkflowForwardingCompleted from "../components/tabs/ForwardingsTab/states/Completed";
import MaintenanceWorkflowForwardingOnGoingCheckin from "../components/tabs/ForwardingsTab/states/OnGoingCheckin";
import MaintenanceWorkflowForwardingOnGoingDirective from "../components/tabs/ForwardingsTab/states/OnGoingDirective";
import MaintenanceWorkflowForwardingOnGoingEstablishmentChoice from "../components/tabs/ForwardingsTab/states/OnGoingEstablishmentChoice";
import { MaintenanceForwardingSectionsProps, MaintenanceForwardingStatus } from "../features/forwardings/types/maintenanceForwarding.type";

export const maintenanceForwardingStatus: Record<MaintenanceForwardingStatus, {
  label: string;
  component: React.ComponentType<MaintenanceForwardingSectionsProps>;
}> = {
  canceled: {
    label: 'Declinado',
    component: MaintenanceWorkflowForwardingCanceled,
  },
  ongoing_establishment_choice: {
    label: 'Aguardando resposta do estabelecimento',
    component: MaintenanceWorkflowForwardingOnGoingEstablishmentChoice,
  },
  ongoing_checkin: {
    label: 'Pendente de check-in',
    component: MaintenanceWorkflowForwardingOnGoingCheckin,
  },
  ongoing_directive: {
    label: 'Análise de diagnóstico e orçamento',
    component: MaintenanceWorkflowForwardingOnGoingDirective,
  },
  completed: {
    label: 'Finalizado',
    component: MaintenanceWorkflowForwardingCompleted,
  },
}
